export enum EnumGroupStatus {
  Wait = 0,
  Success = 1,
  Fail = 2
}
